//= Functions & Modules
// Own
import { NotificationsSystem } from '../components/NotificationsSystem';

export function setNotificationsSystem(notificationsSystem: NotificationsSystem) {
    window.g_notificationsSystem = notificationsSystem;
}
